import { render, staticRenderFns } from "./Pages.vue?vue&type=template&id=0dab3aa2&scoped=true"
import script from "./Pages.vue?vue&type=script&lang=js"
export * from "./Pages.vue?vue&type=script&lang=js"
import style0 from "./Pages.vue?vue&type=style&index=0&id=0dab3aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dab3aa2",
  null
  
)

export default component.exports